"use client"

import { AiOutlineCopyright } from "react-icons/ai"
import "./css/footer2.css" // Asegúrate de tener este archivo CSS

const Footer = () => {
  return (
    <section className="mb-2">
      <div className="mx-4">
        <div className="col-12 d-flex gap-4 justify-content-center footer-copy">
          <span>
            <AiOutlineCopyright className="copyright-icon" /> COPYRIGHT 2025{" "}
          </span>
          <span className="separator"> | </span>
          <span>
            <a href="#Inicio">Agrocorral</a>
          </span>
          <span className="separator"> | </span>
          <span>
            <a href="https://www.yetiadvisers.com/" rel="noopener noreferrer nofollow" target="_blank">
              Powered By YETI ADVISERS
            </a>
          </span>
        </div>
      </div>
    </section>
  )
}

export default Footer
